import api from './api';



export const solicitacaoExecucaoRotinaRelatorioProjetoPacote = () => {
  return api.post('routines/solicitacaoExecucaoRotinaRelatorioProjetoPacote');
}

export const solicitarAtualizacaoRelatorioADistribuirRelatorio = () => {
  return api.post('routines/solicitarAtualizacaoRelatorioADistribuirRelatorio');
}


export const adcionarAnoADistribuirByProjetoIdAndYear = (form: any) => api.post(`routines/adcionarAnoADistribuirByProjetoIdAndYear`, form);


export const getStatusAtualizacaoADistribuirByProjeto = (projetoId: string) => api.get(`routines/GetProcessoAtualizacoesByProjeto/?id=${projetoId}`, { }, { }, 'false');